import React from 'react';
import { Users, Plus, Settings } from 'lucide-react';
import type { InnerCircleGroup } from '../../types/inner-circle';

interface GroupListProps {
  groups: InnerCircleGroup[];
  selectedGroup: string | null;
  onGroupSelect: (groupId: string) => void;
  onCreateGroup: () => void;
  onManageGroup: (group: InnerCircleGroup) => void;
}

export function GroupList({
  groups,
  selectedGroup,
  onGroupSelect,
  onCreateGroup,
  onManageGroup,
}: GroupListProps) {
  const getGroupIcon = (type: InnerCircleGroup['type']) => {
    switch (type) {
      case 'family':
        return '👨‍👩‍👧‍👦';
      case 'business':
        return '💼';
      case 'friends':
        return '🤝';
      default:
        return '👥';
    }
  };

  return (
    <div className="bg-[#2A2B2E] rounded-3xl p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[var(--accent-color)]/20 flex items-center justify-center">
            <Users className="w-5 h-5 text-[var(--accent-color)]" />
          </div>
          <h2 className="text-lg font-medium">Groups</h2>
        </div>
        <button
          onClick={onCreateGroup}
          className="p-2 hover:bg-black/20 rounded-lg transition-colors"
        >
          <Plus className="w-5 h-5" />
        </button>
      </div>

      <div className="space-y-2 overflow-x-auto">
        {groups.map((group) => (
          <div
            key={group.id}
            onClick={() => onGroupSelect(group.id)}
            className={`w-full flex items-center justify-between p-3 rounded-xl transition-colors min-w-[200px] ${
              selectedGroup === group.id
                ? 'bg-[var(--accent-color)] text-black'
                : 'hover:bg-black/20'
            } cursor-pointer`}
          >
            <div className="flex items-center gap-3">
              <span className="text-2xl">{getGroupIcon(group.type)}</span>
              <div className="text-left">
                <h3 className="font-medium">{group.name}</h3>
                {group.description && (
                  <p className="text-sm opacity-80">{group.description}</p>
                )}
              </div>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onManageGroup(group);
              }}
              className={`p-2 rounded-lg transition-colors ${
                selectedGroup === group.id
                  ? 'hover:bg-black/20 text-black'
                  : 'hover:bg-black/20'
              }`}
            >
              <Settings className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}